import React from 'react';
import IngredientInput from '../IngredientInput';

const UNITS = [
  { value: '',         label: '– Einheit –' },
  { value: 'Stk',     label: 'Stück' },
  { value: 'Scheiben',label: 'Scheiben' },
  { value: 'Zehen',   label: 'Zehen' },
  { value: 'Bund',    label: 'Bund' },
  { value: 'Prise',   label: 'Prise' },
  { value: 'Handvoll',label: 'Handvoll' },
  { value: 'TL',      label: 'Teelöffel (TL)' },
  { value: 'EL',      label: 'Esslöffel (EL)' },
  { value: 'ml',      label: 'Milliliter (ml)' },
  { value: 'L',       label: 'Liter (L)' },
  { value: 'g',       label: 'Gramm (g)' },
  { value: 'kg',      label: 'Kilogramm (kg)' },
  { value: 'Dose',    label: 'Dose' },
  { value: 'Pkg',     label: 'Packung' },
  { value: 'Becher',  label: 'Becher' },
];

function unitOptions(currentUnit) {
  const known = UNITS.map(u => u.value);
  const extras = currentUnit && !known.includes(currentUnit)
    ? [{ value: currentUnit, label: currentUnit }]
    : [];
  return [...UNITS, ...extras];
}

const DelIcon = () => (
  <svg viewBox="0 0 24 24">
    <line x1="18" y1="6" x2="6" y2="18"/>
    <line x1="6" y1="6" x2="18" y2="18"/>
  </svg>
);

export default function IngredientsEditor({ ingredients, servings, onIngredientChange, onAdd, onRemove }) {
  return (
    <div className="editor-section">
      <div className="editor-section-head">
        Zutaten
        <span style={{ fontSize: '0.72rem', fontWeight: 500, textTransform: 'none', letterSpacing: 0, color: 'var(--txt3)' }}>
          für {servings} Portionen
        </span>
      </div>
      <div className="editor-section-body">
        {ingredients.map((ing, idx) => (
          <div key={idx} className="ing-editor-row">
            <input
              type="text"
              className="field-input ing-e-amt"
              placeholder="Menge"
              value={ing.amount}
              onChange={e => onIngredientChange(idx, 'amount', e.target.value)}
            />
            <select
              className="field-select ing-e-unit"
              value={ing.unit}
              onChange={e => onIngredientChange(idx, 'unit', e.target.value)}
            >
              {unitOptions(ing.unit).map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
            </select>
            <div className="ing-e-name">
              <IngredientInput
                value={ing.name}
                onChange={val => onIngredientChange(idx, 'name', val)}
              />
            </div>
            <button type="button" className="ing-e-del" onClick={() => onRemove(idx)}>
              <DelIcon />
            </button>
          </div>
        ))}
        <button type="button" className="add-ing-btn" onClick={onAdd}>+ Zutat hinzufügen</button>
      </div>
    </div>
  );
}
